import React from "react";
import { InputAdapter, inputProps } from "./InputAdapter";
import {inputType} from "./inputConstants";

export const EmailField = (props) => {
    return <InputAdapter {...props} inputType={inputType.EMAIL}/>;
};

EmailField.propTypes = {...inputProps};